import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
// import * as jsPDF from '../../../node_modules/jspdf/dist/jspdf.min.js';
import { UseragreementComponent } from '../useragreement/useragreement.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
})
export class SignInComponent implements OnInit {
  loginForm!: FormGroup;
  emailPass: any;
  success: any;
  newUserId!: number;
  newCname!: string;
  newEmail!: string;
  projData: any;
  private formSubmitAttempt!: boolean;
  animal!: string;
  name!: string;
  demoEmail!: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
  //  const firstParam: string | null =
    //  this.route.snapshot.queryParamMap.get('email');
	//let firstParam = this.route.snapshot.params.get('email');
	  let firstParam;
	  this.route.queryParams.subscribe(params => {
      firstParam = params['email'];
      
     
    });
	console.log(' First param '+firstParam);
    // const secondParam: string = this.route.snapshot.queryParamMap.get('pass');
    // this.demoEmail = firstParam;
    if (firstParam == 'demo@ecomatrix.io') {
		console.log(' In if ');
      (<HTMLElement>document.querySelector('#formpage')).style.display = 'none';
      //  document.getElementsByClassName("loginForm").style
      const validateUser = this.authService.login({
        email: 'demo@ecomatrix.io',
        pwd: '123456',
      });
      if (validateUser) {
        validateUser.subscribe((data: any) => {
          this.emailPass = data;
          this.emailPass.clientName = 'Guest';
          if (this.emailPass.success == 1) {
            this.authService.changeUserId(this.emailPass.clientId);
            this.authService.newClientName(this.emailPass.clientName);
            this.authService.newClientEmail(this.emailPass.clientEmail);
            this.authService.changeAshNecb('Ashare');
            this.authService.gtvalFirst();
            /*  this.snackBar.open('Login successfully', 'clear', {
                  duration: 5000,
                }); */

            (<HTMLButtonElement>(
              document.getElementById('emailpass')
            )).style.display = 'none';
            this.authService.userLogedin();

            this.router
              .navigateByUrl('/logedin', { skipLocationChange: true })
              .then(() => this.router.navigate(['chart']));

            // this.router.navigate(["chart"]);
          }

          if (this.emailPass.success == 3) {
            (<HTMLButtonElement>(
              document.getElementById('emailpass')
            )).style.display = 'block';
            // document.getElementById("emailpass").style.display = "block";
            this.snackBar.open(
              'User not registered, Please register',
              'clear',
              {
                duration: 5000,
              }
            );
            this.authService.seeLogin();
          }
        });
      }
    } // end of auto login

    (<HTMLButtonElement>document.getElementById('emailpass')).style.display =
      'none';
    this.authService.currentUserId.subscribe(
      (newUserId: number) => (this.newUserId = newUserId)
    );
    this.authService.currentClientName.subscribe(
      (newCname: string) => (this.newCname = newCname)
    );
    this.authService.currentClientEmail.subscribe(
      (newEmail: string) => (this.newEmail = newEmail)
    );

    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
      ]),
      pwd: new FormControl('', Validators.required),
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const validateUser = this.authService.login(this.loginForm.value);
      if (validateUser) {
        validateUser.subscribe((data: any) => {
          this.emailPass = data;
          if (this.emailPass.success == 1) {
            this.authService.changeUserId(this.emailPass.clientId);
            this.authService.newClientName(this.emailPass.clientName);
            this.authService.newClientEmail(this.emailPass.clientEmail);

            this.snackBar.open('Login successfully', 'clear', {
              duration: 5000,
            });

            (<HTMLButtonElement>(
              document.getElementById('emailpass')
            )).style.display = 'none';
            this.authService.userLogedin();
            if (this.emailPass.firstTimeLogin == 'T') {
              const dialogRef = this.dialog.open(UseragreementComponent, {
                width: '800px',
                height: '500px',
                data: { name: this.name, animal: this.animal },
              });
            }
            this.router
              .navigateByUrl('/logedin', { skipLocationChange: true })
              .then(() => this.router.navigate(['mrfd']));
          }

          if (this.emailPass.success == 3) {
            (<HTMLButtonElement>(
              document.getElementById('emailpass')
            )).style.display = 'block';
            this.snackBar.open(
              'User not registered, Please register',
              'clear',
              {
                duration: 5000,
              }
            );
            this.authService.seeLogin();
          }
        });
      }
    }
    this.formSubmitAttempt = true;
  }
}
